import Money from '../../Types/Money';

import { LotteryType } from './LotteryResponse';

import { DrawNumbers } from 'components/play/Types/Types';

export enum TicketStatus {
    PENDING = 'pending',
    WON = 'won',
    NOWINNINGS = 'nowinnings',
    CANCELED = 'canceled',
}

export enum DiscountSource {
    PROMOCODE = 'promocode',
    REFER_A_FRIEND = 'refer_a_friend',
}

export enum DiscountType {
    TICKET = 'ticket',
    AMOUNT_DISCOUNT = 'amount_discount',
    PERCENTAGE_DISCOUNT = 'percentage_discount',
}

export type PromoCode = {
    readonly id: number;
    readonly promo_code_campaign_id: number;
    readonly value: string;
    readonly uses: number;
};

export type PromoCodeCampaign = {
    id: number;
    use_place: 'deposit' | 'purchase' | 'register';
    lottery_id: number | null;
};

type GetLotteryTicketResponse = {
    readonly id: number;
    readonly official_uuid: string | null;
    readonly user_id: number;
    readonly lottery_multi_draw_ticket_id: number | null;
    readonly ticket_type: string;
    readonly lottery_id: number;
    readonly lottery_rule_id: number | null;
    readonly lottery_rule_tier_multiplier_id: number | null;
    readonly game_type: string | null;
    readonly game_type_slug: string | null;
    readonly multiplier: string | null;
    readonly lottery_draw_id: number | null;
    readonly reseller_customer_id: number | null;
    readonly token: string | null;
    readonly draw_date: string | null;
    readonly system_sell_amount_net: number;
    readonly system_sell_amount_gross: number;
    readonly system_sell_amount_currency_code: string | null;
    readonly sale_tax_percent: number;
    readonly system_sale_tax_fixed: number;
    readonly system_sale_tax_sum: number;
    readonly reseller_revenue: number;
    readonly status: TicketStatus;
    readonly paid_out: boolean;
    readonly paid_out_reseller_id: number | null;
    readonly prize_tax_percent: number | null;
    readonly lottery_prize_gross: number | null;
    readonly lottery_prize_currency_code: string | null;
    readonly is_synced: boolean;
    readonly ip: string | null;
    readonly ip_country_code: string | null;
    readonly created_at: string | null;
    readonly updated_at: string | null;
    readonly promo_code_campaign_id: number | null;
    readonly promo_code_id: number | null;
    readonly discount_source: DiscountSource | null;
    readonly discount_type: DiscountType | null;
    readonly system_discount_amount: number | null;
    readonly system_ticket_value: number;

    // additional props
    readonly promo_code_campaign: PromoCodeCampaign | null;
    readonly promo_code: PromoCode | null;
    readonly email: string | null;
    readonly phone: string | null;
    readonly name: string | null;
    readonly surname: string | null;
    readonly print_count: number;
    readonly type: string;
    readonly lottery_timezone: string;
    readonly lottery_slug: string;
    readonly lottery_name: string;
    readonly lottery_type: LotteryType;
    readonly reseller_customer_email: string | null;
    readonly draw_numbers: DrawNumbers;
    readonly can_be_paid_out: boolean;
    readonly prizeNet: Money | null;
    readonly prizeGross: Money | null;
    readonly prizeTaxFixed: Money | null;
    readonly prizeTaxSum: Money | null;
    readonly systemPrizeNet: Money | null;
    readonly systemPrizeGross: Money | null;
    readonly systemPrizeTaxFixed: Money | null;
    readonly systemPrizeTaxSum: Money | null;
    readonly lotteryPrizeGross: Money | null;
    readonly ticket_markup: number | null;
};

export default GetLotteryTicketResponse;
